/**
 * 管理端用户名展示：姓名 + 本店用户备注（仅展示拼接，不改库里的用户名）。
 */
export function pickUserDisplayName(row?: any | null, nameKeys: string[] = ['name', 'userName', 'consignee']): string {
  if (!row) return ''
  for (let i = 0; i < nameKeys.length; i++) {
    const v = row[nameKeys[i]]
    if (v != null && String(v).trim()) return String(v).trim()
  }
  return ''
}

/**
 * 本店用户备注：
 * - 默认只用 userRemark（订单行勿回落到 remark，否则会把「联单货/联单购:PKGID」等内部标记当作用户备注）
 * - 用户列表 preferRemark=true 时：remark 字段本身就是本店备注
 */
export function pickUserStoreRemark(
  row?: any | null,
  opts?: { preferRemark?: boolean }
): string {
  if (!row) return ''
  const remarkVal = row.remark != null && String(row.remark).trim() ? String(row.remark).trim() : ''
  const userRemarkVal =
    row.userRemark != null && String(row.userRemark).trim() ? String(row.userRemark).trim() : ''
  if (opts && opts.preferRemark) {
    return remarkVal || userRemarkVal
  }
  return userRemarkVal
}

export function formatUserNameWithRemark(
  name?: string | null,
  remark?: string | null
): { name: string; remark: string } {
  return {
    name: name != null && String(name).trim() ? String(name).trim() : '—',
    remark: remark != null && String(remark).trim() ? String(remark).trim() : '',
  }
}
